module.exports = __webpack_public_path__ + "img/r1-en.666a9650.jpeg";